export class Banco {
    banco : string;
    agencia : string;
    conta : string;
}